/* istanbul ignore file */
import React from 'react';
import OpportunitiesBreadcrumbs from 'domain/sales/opportunity/shared/OpportunitiesBreadcrumbs';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const CreateOpportunityBreadcrumbs = () => (
  <OpportunitiesBreadcrumbs>
    <CreateBreadcrumbItem entity="Opportunity" />
  </OpportunitiesBreadcrumbs>
);

export default CreateOpportunityBreadcrumbs;
